/**
 * ScaleQuestionUI - 5段階評価コンポーネント (モック_GB組織_回答画面_v1.html s2/s3/s5/s8 準拠)
 * Part2/3/4/7用: タップで回答記録＋自動進行
 * 1〜5の数字ボタンを連結した横並び (.gb74-scale-row)、両端ラベルを下部に表示する。
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { SupportedLanguage } from '../types/questionnaire.types';
import { SCALE_LABELS } from '../../../utils/multiLanguageText';

interface ScaleQuestionUIProps {
  questionText: string;
  /** パート別リード文 (モックの .q-text。例: 「先月の1か月を振り返って…」) */
  leadText?: string;
  questionNumber: number;
  totalQuestions: number;
  selectedValue?: number;
  onAnswer: (scaleValue: number) => void;
  onBack: () => void;
  canGoBack: boolean;
}

export const ScaleQuestionUI: React.FC<ScaleQuestionUIProps> = ({
  questionText,
  leadText,
  selectedValue,
  onAnswer,
  onBack,
  canGoBack,
}) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language as SupportedLanguage;
  const labels = SCALE_LABELS[lang] ?? SCALE_LABELS.ja;

  return (
    <>
      {leadText && <p className="gb74-q-lead">{leadText}</p>}
      <h2 className="gb74-q-sub">{questionText}</h2>
      <div>
        <div className="gb74-scale-row">
          {[1, 2, 3, 4, 5].map((value) => (
            <button
              key={value}
              type="button"
              className={`gb74-scale-btn${selectedValue === value ? ' sel' : ''}`}
              onClick={() => onAnswer(value)}
            >
              {value}
            </button>
          ))}
        </div>
        <div className="gb74-scale-labels">
          <span>{labels[0]}</span>
          <span>{labels[4]}</span>
        </div>
      </div>
      {canGoBack && (
        <p className="gb74-back">
          <button type="button" onClick={onBack}>
            {t('questionnaire.previousQuestion')}
          </button>
        </p>
      )}
    </>
  );
};
